import { useMedia } from "@tamagui/core";
const useSelectBreakpointActive = (sheetBreakpoint) => {
  const media = useMedia();
  if (!sheetBreakpoint)
    return false;
  if (sheetBreakpoint === true)
    return true;
  return sheetBreakpoint ? media[sheetBreakpoint] : false;
};
const useShowSelectSheet = (context) => {
  const breakpointActive = useSelectBreakpointActive(context.sheetBreakpoint);
  return context.open === false ? false : breakpointActive;
};
export {
  useSelectBreakpointActive,
  useShowSelectSheet
};
//# sourceMappingURL=useSelectBreakpointActive.js.map
